// Generated from assets/icons/iconStart-6.svg (TA-11013).
// Ids are derived per instance via useSvgIdPrefix() so two copies on one
// screen cannot collide. Edit this file rather than re-adding the .svg.
import * as React from 'react';
import Svg, { G, Path, Defs, ClipPath } from 'react-native-svg';

import { useSvgIdPrefix } from '@hooks/useSvgIdPrefix';

import type { SvgProps } from 'react-native-svg';

export const IconStart6 = (props: SvgProps) => {
  const uid = useSvgIdPrefix();
  return (
    <Svg fill='none' viewBox='0 0 24 24' {...props}>
      <G clipPath={`url(#${uid}-a)`}>
        <G clipPath={`url(#${uid}-b)`}>
          <Path
            fill='currentColor'
            d='M19.35-.4a2.25 2.25 0 0 1 2.25 2.25v19.5a2.25 2.25 0 0 1-2.25 2.25h-4.5v-3.75a2.25 2.25 0 0 0-4.5 0v3.75h-4.5a2.25 2.25 0 0 1-2.25-2.25V1.85A2.25 2.25 0 0 1 5.85-.4zM6.6 12.35c0 .412.336.75.75.75h1.5c.413 0 .75-.338.75-.75v-1.5a.75.75 0 0 0-.75-.75h-1.5a.75.75 0 0 0-.75.75zm5.25-2.25a.75.75 0 0 0-.75.75v1.5c0 .412.338.75.75.75h1.5c.413 0 .75-.338.75-.75v-1.5a.75.75 0 0 0-.75-.75zm3.75 2.25c0 .412.338.75.75.75h1.5c.413 0 .75-.338.75-.75v-1.5a.75.75 0 0 0-.75-.75h-1.5a.75.75 0 0 0-.75.75zM7.35 4.1a.75.75 0 0 0-.75.75v1.5c0 .412.336.75.75.75h1.5c.413 0 .75-.338.75-.75v-1.5a.75.75 0 0 0-.75-.75zm3.75 2.25c0 .412.338.75.75.75h1.5c.413 0 .75-.338.75-.75v-1.5a.75.75 0 0 0-.75-.75h-1.5a.75.75 0 0 0-.75.75zm5.25-2.25a.75.75 0 0 0-.75.75v1.5c0 .412.338.75.75.75h1.5c.413 0 .75-.338.75-.75v-1.5a.75.75 0 0 0-.75-.75z'
          />
        </G>
      </G>
      <Defs>
        <ClipPath id={`${uid}-a`}>
          <Path fill='white' d='M0 0h24v24H0z' />
        </ClipPath>
        <ClipPath id={`${uid}-b`}>
          <Path fill='white' d='M3.6-.4h18v24h-18z' />
        </ClipPath>
      </Defs>
    </Svg>
  );
};
